export default function Hero() {
  return (
    <section className="bg-gradient-to-r from-purple-700 via-purple-800 to-indigo-900 text-white py-20 text-center px-6">
      <h1 className="text-4xl md:text-5xl font-bold mb-4">
        Learn anything, anytime, anywhere
      </h1>
      <p className="text-lg md:text-xl mb-6">
        Join millions of learners mastering new skills with Smarty.
      </p>
      <button className="bg-white text-purple-800 font-semibold px-6 py-3 rounded-full shadow-lg hover:bg-gray-200 transition">
        Explore Courses
      </button>
    </section>
  );
}
